<template>
  <div v-if="!hidden">
    <QuestionLabel
      :number="question.questionNumber"
      :text="question.text"
    ></QuestionLabel>
    <div class="pb-6">
      <div class="mb-16" key="dense">
        <div class="mt-3 mb-8">
          <table class="w-100">
            <thead>
              <th class="pl-0 pb-4"></th>
              <th
                class="vertical-align-bottom text-right text-capitalize"
                style="width: 100px"
              >
                Percentage
              </th>
            </thead>
            <tr v-for="child in question.children" :key="child.key">
              <td class="w-100 py-4 d-flex">
                <v-chip
                  v-if="child.questionNumber && child.questionNumber.length > 0"
                  color="secondary"
                  class="text-capitalize mr-4 flex-shrink-0"
                >
                  {{ child.questionNumber }}
                </v-chip>
                <div class="d-flex align-center">
                  <survey-question-text
                    :text="child.text"
                  ></survey-question-text>
                </div>
              </td>
              <td class="text-right text-no-wrap">
                {{ getRate(child.key) | percentage }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  th,
  td {
    padding: 0.25rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import numeral from "numeral";

import QuestionLabel from "./QuestionReport.Label.vue";
import SurveyQuestionText from "./Survey.Question.Text.vue";

export default {
  name: "QuestionReportListResponseRate",
  components: { QuestionLabel, SurveyQuestionText },
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  data: () => ({}),
  props: {
    survey: Object,
    question: Object,
    agg: Object,
    dense: Boolean,
  },
  computed: {
    smallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hidden() {
      return this.settings.private === "true";
    },
    settings() {
      var result = {};

      this.question.settings.forEach((x) => {
        result[x.key] = x.value;
      });

      return result;
    },
  },
  methods: {
    questionData(questionKey) {
      var results = this.agg.results.filter((x) => x.key === questionKey);
      if (results.length == 0) return null;
      else return results[0];
    },
    getRate(questionKey) {
      let data = this.questionData(questionKey);
      if (!data) return 0;

      var numerator =
        data.counts.find((x) => x.key.toLowerCase() == "true")?.value ?? 0;

      var denominator = 0;

      if (this.question.responseCountTarget) {
        denominator = this.question.responseCountTarget;
      } else if (this.survey.responseCountTarget) {
        denominator = this.survey.responseCountTarget;
      } else if (data.responses) {
        denominator = data.responses;
      } else {
        denominator = this.agg.responseCount;
      }

      if (!numerator) return 0;
      else return numerator / denominator;
    },
  },
};
</script>
